/**
 * A missing wall that IS the wall (PRP-SKETCH-FIELD-4 K5, N5): the 0 in shared wall of a
 * split line, or a wall removed end to end. It selects like a wall on the first tap (the
 * wall's panel, with Edit for the missing-wall sheet) and drags as a shared wall (J17).
 * A partial missing wall (an opening in a wall that stays) is still an opening: it
 * selects as one and slides along its wall (K11).
 */
import { EPS, dist, edgeOf, findRoom } from './geom';
import { wallIn } from './thickness';
import type { Plan, Room } from './types';

/** The missing opening on wall `vid` that covers the whole 0 in wall, if any. */
export function wallMissing(r: Room, vid: number): Room['openings'][number] | null {
  const E = edgeOf(r, vid);
  if (!E || wallIn(r, vid) > EPS) return null;
  return r.openings.find((o) => o.edgeStart === vid && o.kind === 'missing') ?? null;
}

/** K5: the wall a tapped missing opening stands for, when it is the whole 0 in wall; else null. */
export function missingAsWall(plan: Plan, rid: string, oid: number): { rid: string; vid: number; off: number } | null {
  const r = findRoom(plan, rid);
  const o = r?.openings.find((q) => q.id === oid);
  if (!r || !o || o.kind !== 'missing' || wallIn(r, o.edgeStart) > EPS) return null;
  const E = edgeOf(r, o.edgeStart);
  if (!E) return null;
  return { rid, vid: o.edgeStart, off: Math.min(dist(E.a, E.b), o.offFt + o.widthFt / 2) };
}
